module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flash-black-phone-poster.960cbeee.jpg";